<template>
  <div class="main">
    <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="modelMenu" current="客户价值分析" />
      <div class="r action-btn-box" v-show="!viewResult">
        <el-button @click="selectCars"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >客户价值分析 <svg-icon name="play" size="12" ></svg-icon> </el-button>
      </div>
      <xy-toolbox-menu class="r" v-show="viewResult">
        <xy-toolbox-menu-item icon="car_search" @click="chooseCars">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="swap" @click="swapLine">交换车款</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
    </SearchBar>

    <div v-if="viewResult" class="view-main">
      <xy-toolbox-menu>
        <xy-toolbox-menu-item custom>
          <div class="custom-content">
            <el-select v-model="viewValue" placeholder="选择细分市场" @change="pvaParse">
              <el-option v-for="item in segments" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </xy-toolbox-menu-item>

      </xy-toolbox-menu>

      <el-tabs type="border-card" :key="refreshId">
        <el-tab-pane v-for="it of pklist" :key="it.id" :label="it.title" :title="it.title">
          <div style="width:100%; margin-left:10px margin-right:10px; margin-bottom:30px;" id="equipdata">
            <div id="head">
              <div class="row head">
                <div class="col"></div>
                <div class="col w250 line-title" :title="it.left.name">{{it.left.name}}</div>
                <div class="col w250 line-title" :title="it.right.name">{{it.right.name}}</div>
                <div class="col">△PVA值</div>
              </div>

              <div class="row" v-for="(item,index) in pvaResult[it.id].head" :key="index" v-show="!item.hideen">
                <div class="col">{{item.name}}</div>
                <div class="col w250">{{item.a_val}}</div>
                <div class="col w250">{{item.b_val}}</div>
                <div class="col">{{ item.diff }}</div>
              </div>
            </div>

            <el-collapse v-model="activeNames">
              <el-collapse-item :name="it.id+'_1'">
                <template slot="title">
                  <h3 class="cat-title">装备对比优势（根据△PVA正负进行判断）</h3>
                </template>
                <div class="row head">
                  <div class="col">名称</div>
                  <div class="col">装备情况</div>
                  <div class="col">装备PVA值</div>
                  <div class="col">装备情况</div>
                  <div class="col">装备PVA值</div>
                  <div class="col">△PVA值</div>
                </div>
                <div class="row" v-for="(item,index) in  pvaResult[it.id].advantage" :key="index">
                  <div class="col">{{item.name}}</div>
                  <div class="col">{{item.a_opt}}</div>
                  <div class="col">{{item.a_val}}</div>
                  <div class="col">{{item.b_opt}}</div>
                  <div class="col">{{item.b_val}}</div>
                  <div class="col">{{item.diff}}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item :name="it.id+'_2'">
                <template slot="title">
                  <h3 class="cat-title">装备对比劣势（根据△PVA正负进行判断）</h3>
                </template>
                <div class="row head">
                  <div class="col">名称</div>
                  <div class="col">装备情况</div>
                  <div class="col">装备PVA值</div>
                  </SearchBar>
                  <div class="col">装备情况</div>
                  <div class="col">装备PVA值</div>
                  <div class="col">△PVA值</div>
                </div>
                <div class="row" v-for="(item,index) in pvaResult[it.id].inferifor" :key="index">
                  <div class="col">{{item.name}}</div>
                  <div class="col">{{item.a_opt}}</div>
                  <div class="col">{{item.a_val}}</div>
                  <div class="col">{{item.b_opt}}</div>
                  <div class="col">{{item.b_val}}</div>
                  <div class="col">{{item.diff}}</div>
                </div>
              </el-collapse-item>
              <el-collapse-item :name="it.id+'_3'">
                <template slot="title">
                  <h3 class="cat-title">低议价</h3>
                </template>
                <div class="row head">
                  <div class="col">名称</div>
                  <div class="col">装备情况</div>
                  <div class="col">装备PVA值</div>
                  <div class="col">装备情况</div>
                  <div class="col">装备PVA值</div>
                  <div class="col">△PVA值</div>
                </div>
                <div class="row" v-for="(item,index) in  pvaResult[it.id].zero" :key="index">
                  <div class="col">{{item.name}}</div>
                  <div class="col">{{item.a_opt}}</div>
                  <div class="col">{{item.a_val}}</div>
                  <div class="col">{{item.b_opt}}</div>
                  <div class="col">{{item.b_val}}</div>
                  <div class="col">{{item.diff}}</div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" width="70%" :before-close="hideDialog" :center="false" :show-close="false" :append-to-body="true">
      <span class="dialog-title clearfix" slot="title">
        <span>PK</span>
      </span>
      <div class="pkhead">
        <el-button class="vs-icon" @click="handleSwap()" size="medium">
          <svg-icon name="swap" size="20"></svg-icon>
        </el-button>
        <div class="pktitle">本品</div>
        <div class="pktitle">竞品</div>
      </div>
      <div class="vsbox">
        <svg-icon name="pk" size="40" class="vs-icon"></svg-icon>
        <div class="block">
          <draggable v-model="self" element="ul" class="car-list" :options="dragOptions">
            <li v-for="(item,index) of self" :key="index" class="left">
              <el-link icon="el-icon-delete" class="left-remove" @click="removeCar(1,index)"></el-link>
              <el-link icon="el-icon-document-add" class="left-copy" @click="copyCar(1,index)"></el-link>
              <span class="text">{{item.name}} | {{item.msrp}}</span>
              <el-button size="small" icon="el-icon-arrow-right" circle @click="handleSwap(1,index)"></el-button>
            </li>
          </draggable>
        </div>
        <div class="block">
          <draggable v-model="competingCars" element="ul" class="car-list" :options="dragOptions">
            <li v-for="(item,index) of competingCars" :key="index" class="right">
              <el-button size="small" icon="el-icon-arrow-left" circle @click="handleSwap(2,index)"></el-button>
              <span class="text">{{item.name}} | {{item.msrp}}</span>
              <el-link icon="el-icon-delete" class="right-remove" @click="removeCar(2,index)"></el-link>
            </li>
          </draggable>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="hideDialog" style="margin-right:10px;">返回</el-button>
        <el-select v-model="viewValue" placeholder="选择细分市场" style="margin-right:10px">
          <el-option v-for="item in segments" :key="item" :label="item" :value="item"></el-option>
        </el-select>

        <el-button type="primary" @click="pvaParse">PVA分析</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/NewSearchBar.vue";
import { formatDate, strToFormatDate } from "@/plugins/DateTimeFormater.js";
import { compare, bubbleSort } from "@/plugins/sort.js";
import draggable from "vuedraggable";
import XLSX from "xlsx";
import { Alert } from 'element-ui';
const DataKey = {
  OnlyEquip: 1,
  MSRP: 2,
  DealerPrice: 3,
  MSRPChanged: 4,
  DealerPriceChanged: 5,
  MSRPPVA: 6,
  DealerPricePVA: 7,

};
export default {
  name: "EquipPVA",
  components: {
    SearchBar,
    draggable
  },
  data() {
    return {
      viewResult: false,
      segments: [
        "A",
        "A0",
        "A00",
        "A00_SUV",
        "A0_MPV",
        "A0_SUV",
        "A_MPV",
        "A_SUV",
        "B",
        "B_MPV",
        "B_SUV",
        "C",
        "COUPE",
        "C_MPV",
        "C_SUV",
        "D",
        "D_SUV"
      ],
      viewValue: "A",
      activeNames: [],
      currentModuleName: "EquipPVA",
      advantageList: [],
      inferiorList: [],
      zeroList: [],
      headList: [],
      showDialog: false,
      exchange: false,
      self: [],
      competingCars: [],
      pklist: [],

      pvaResult: {},
      refreshId: 0
    };
  },
  methods: {
    ...mapActions("equipanalysis", ["queryPVA"]),
    chooseCars() {
      this.pvaResult.length = 0;
      this.viewResult = false;
      this.viewValue = '';
    },
    pvaParse() {
      if (this.self.length != this.competingCars.length) {
        this.$message({ message: "本品和竞品数量不一致", duration: 2000 });
        return;
      }
      if (this.viewValue == '') {
        this.$message({ message: "请选择一个细分市场", duration: 2000 });
        return;
      }
      this.viewResult = true;
      this.showTabs();
      this.showDialog = false;
      var cars = this.self.concat(this.competingCars);
      let arrNew = new Set(cars.map(x => x.carId)); //通过set集合去重
      var lineIds = Array.from(arrNew);
      var postData = { ids: lineIds, val: this.viewValue };
      this.queryPVA({ params: postData, handle: this.bindPVA });//this.bindPVA
    },

    showTabs() {
      this.pklist.length = 0;
      this.activeNames.length = 0;
      for (var i = 0; i < this.self.length; i++) {
        var left = this.self[i];
        var right = this.competingCars[i];
        var title = "..." + left.name.substring(left.name.length - 8) + " VS " + "..." + right.name.substring(right.name.length - 8);

        var _id = "p" + left.carId + "_" + right.carId;
        this.activeNames.push(_id + '_1');
        this.activeNames.push(_id + '_2');
        this.activeNames.push(_id + '_3');
        this.pvaResult[_id] = { advantage: [], inferifor: [], zero: [], head: [] };
        this.pklist.push({
          title: title,
          left: left,
          right: right,
          id: _id,
          content: '<div class="item goodness">loading ... </div>'
        });
      }
    },
    bindPVA(isOK) {

      for (let item of this.pklist) {
        let left = item.left;
        let right = item.right;
        var alist = this.pva.pva.filter(item => item.id == left.carId);
        var blist = this.pva.pva.filter(item => item.id == right.carId);


        var abNames = new Set(alist.concat(blist).map(x => x.name));
        var names = Array.from(abNames);
        //alert(JSON.stringify(names));
        this.bindPKContent(item, names, alist, blist);
      }
      this.refreshId++;

    },
    swapLine() {

      if (this.pklist.length == 0) {
        return;
      }

      for (var v of this.pklist) {
        [v.left, v.right] = [v.right, v.left];

      }

      this.bindPVA(true);
    },
    bindPKContent(pkInfo, names, alist, blist) {


      var advantageList = [];
      var inferiorList = [];
      var zeroList = [];
      var headList = [];

      for (var item of names) {
        var a_cur = alist.find(x => x.name == item);
        var b_cur = blist.find(x => x.name == item);

        var a_opt = this.formatterOpt(a_cur);
        var b_opt = this.formatterOpt(b_cur);
        var b_val = this.getPVAValue(b_cur);
        var a_val = this.getPVAValue(a_cur);
        var diff = a_val - b_val;
        const data = {
          name: item,
          a_opt: a_opt,
          a_val: a_val,
          b_opt: b_opt,
          b_val: b_val,
          diff: diff
        };

        if (diff == 0) {
          zeroList.push(data);
        } else if (a_cur && diff >= 0) {
          advantageList.push(data);

        } else if (b_cur && diff <= 0) {

          inferiorList.push(data);
        }

        /*      
          if (a_cur && !b_cur && a_val > 0) {
            advantageList.push(data);
          } else if (b_cur && !a_cur && b_val > 0) {
            inferiorList.push(data);
          } else if (diff == 0) {
             zeroList.push(data);
          } else if (b_val && a_val > b_val) {
             advantageList.push(data);
          }  
          
        else   {
           inferiorList.push(data);
         }
  */
      }
      bubbleSort(advantageList, (a, b) => a.diff - b.diff);
      bubbleSort(inferiorList, (a, b) => a.diff - b.diff);
      bubbleSort(zeroList, (a, b) => a.a_val - b.a_val);

      var pvaDiff = this.totalPVA(alist) - this.totalPVA(blist);
      headList = [
        {
          name: "仅装备",
          a_val: this.totalPVA(alist),
          b_val: this.totalPVA(blist),
          diff: pvaDiff,
          hideen: false
        },
        {
          name: "MSRP",
          a_val: this.getDataVal(pkInfo.left.carId, DataKey.MSRP),
          b_val: this.getDataVal(pkInfo.right.carId, DataKey.MSRP),
          diff:
            this.getDataVal(pkInfo.left.carId, DataKey.MSRP) -
            this.getDataVal(pkInfo.right.carId, DataKey.MSRP),
          hideen: false
        }
      ];

      var ainfo = this.pva.info.filter(x => x.lineId == pkInfo.left.carId);
      var binfo = this.pva.info.filter(x => x.lineId == pkInfo.right.carId);
      var hideen = ainfo.tp == 0 && binfo.tp == 0;


      if (!hideen) {
        headList.push({
          name: "Dealer Price", a_val: this.getDataVal(pkInfo.left.carId, DataKey.DealerPrice), b_val: this.getDataVal(pkInfo.right.carId, DataKey.DealerPrice),
          diff: this.getDataVal(pkInfo.left.carId, DataKey.DealerPrice) - this.getDataVal(pkInfo.right.carId, DataKey.DealerPrice),
          hideen: false
        });
      }
      var msrp_changed =
        this.getDataVal(pkInfo.left.carId, DataKey.MSRP) + pvaDiff;
      headList.push({
        name: "MSRP调整后价格",
        a_val: this.getDataVal(pkInfo.left.carId, DataKey.MSRP),
        b_val: msrp_changed,
        diff: "-",
        hideen: false
      });

      // {name:'MSRP PVA' ,a_val:'',b_val:'',diff:'0',hideen:false },
      // {name:'Dealer Price PVA' ,a_val:'',b_val:'',diff:'0',hideen:false },
      var index = hideen ? 2 : 3;
      var msrpPVA =
        (
          (headList[index].b_val / headList[index].a_val) *
          100
        ).toFixed(1) + "%";
      headList.push({ name: "MSRP PVA", a_val: "", b_val: msrpPVA, diff: "-", hideen: false });

      if (!hideen) {
        var dpPav =
          (
            (this.getDataVal(pkInfo.left.carId, DataKey.DealerPrice) / this.getDataVal(pkInfo.right.carId, DataKey.DealerPrice)) *
            100
          ).toFixed(1) + "%";
        headList.push({ name: "Dealer Price PVA", a_val: "", b_val: dpPav, diff: "-", hideen: false });
      }




      this.pvaResult[pkInfo.id] = {
        advantage: advantageList,
        inferifor: inferiorList,
        zero: zeroList,
        head: headList
      };

    },
    selectCars() {
      let compareCars = this.selectionResult;

      if (compareCars.length < 2) {
        this.$message({
          message: "至少选项2个车型/车款",
          duration: 2000
        });
        return;
      }

      this.self = [];
      this.competingCars = [];
      for (var i = 0; i < compareCars.length; i++) {
        let car = compareCars[i];
        if (i % 2 == 0) {
          this.self.push({
            id: i,
            modeId: car.modeId,
            carId: car.id,
            name: car.name,
            msrp: Number(car.msrp),
            dealPrice: car.tp
          });
        } else {
          this.competingCars.push({
            id: i,
            modeId: car.modeId,
            carId: car.id,
            name: car.name,
            msrp: Number(car.msrp),
            dealPrice: car.tp
          });
        }
      }

      this.openDialog();
    },
    handleSwap(t, index) {
      if (t) {
        if (t == 1) {
          let car = this.self[index];
          this.competingCars.push(car);
          this.self.splice(index, 1);
        } else if (t == 2) {
          let car = this.competingCars[index];
          this.self.push(car);
          this.competingCars.splice(index, 1);
        }
      } else {
        [this.self, this.competingCars] = [this.competingCars, this.self];
      }
    },
    removeCar(t, index) {
      if (t == 1) {
        this.self.splice(index, 1);
      } else {
        this.competingCars.splice(index, 1);
      }
    },
    copyCar(t, index) {
      var car = JSON.parse(JSON.stringify(this.self[index]));
      car.index++;
      this.self.splice(index, 0, car);
      for (var i = index; i < this.self.length; i++) {
        this.self[i].id++;
      }
    },
    openDialog() {
      this.showDialog = true;
    },
    hideDialog() {
      this.showDialog = false;
    },

    getPVAValue(item) {
      if (!item) {
        return 0;
      }
      //计算属性
      return item.value;
    },




    formatterOpt(item) {
      if (!item || !item.opt || item.opt == "") {
        return "-";
      }
      if (item.name == item.opt) {
        return "S";
      }
      return item.opt;
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    exportExcel() {

      var new_workbook = XLSX.utils.book_new();
      var sheetId = 1;
      for (var it of this.pklist) {

        var v = this.pvaResult[it.id];
        let excelData = [];

        var cols = {
          c1: "名称",
          c2: it.left.name,
          c3: "本品值",
          c4: it.right.name,
          c5: "竞品值",
          c6: "△PVA值"
        };
        var c2 = it.right.name;
        for (const item of v.head) {
          var cur = {};
          cur[cols.c1] = item.name;
          cur[cols.c2] = item.a_val;
          cur[cols.c3] = "";
          cur[cols.c4] = item.b_val;
          cur[cols.c5] = "";
          cur[cols.c6] = item.diff;
          excelData.push(cur);
        }
        var head = {};
        head[cols.c1] = "名称";
        head[cols.c2] = "装备情况";
        head[cols.c3] = "装备PVA值";
        head[cols.c4] = "装备情况";
        head[cols.c5] = "装备PVA值";
        head[cols.c6] = "△PVA值";
        if (v.advantage.length > 0) {
          excelData.push(head);
          //{ name:item,a_opt:a_opt, a_val:a_val ,b_opt:b_opt ,b_val : b_val,diff:diff};
          for (const item of v.advantage) {
            var cur = {};
            cur[cols.c1] = item.name;
            cur[cols.c2] = item.a_opt;
            cur[cols.c3] = item.a_val;
            cur[cols.c4] = item.b_opt;
            cur[cols.c5] = item.b_val;
            cur[cols.c6] = item.diff;
            excelData.push(cur);
          }
        }
        if (v.inferifor.length > 0) {
          excelData.push(head);
          //{ name:item,a_opt:a_opt, a_val:a_val ,b_opt:b_opt ,b_val : b_val,diff:diff};
          for (const item of v.inferifor) {
            var cur = {};
            cur[cols.c1] = item.name;
            cur[cols.c2] = item.a_opt;
            cur[cols.c3] = item.a_val;
            cur[cols.c4] = item.b_opt;
            cur[cols.c5] = item.b_val;
            cur[cols.c6] = item.diff;
            excelData.push(cur);
          }
        }

        if (v.zero.length > 0) {
          excelData.push(head);
          //{ name:item,a_opt:a_opt, a_val:a_val ,b_opt:b_opt ,b_val : b_val,diff:diff};
          for (const item of v.zero) {
            var cur = {};
            cur[cols.c1] = item.name;
            cur[cols.c2] = item.a_opt;
            cur[cols.c3] = item.a_val;
            cur[cols.c4] = item.b_opt;
            cur[cols.c5] = item.b_val;
            cur[cols.c6] = item.diff;
            excelData.push(cur);
          }
        }
        // JSONToExcel(excelData, "装备PVA", "PVA");
        var worksheet = XLSX.utils.json_to_sheet(excelData, { header: ["名称", it.left.name, "本品值", it.right.name, "竞品值", "△PVA值"], skipHeader: false });
        worksheet["!merges"] = [{ s: { c: 1, r: 0 }, e: { c: 2, r: 0 } }, { s: { c: 3, r: 0 }, e: { c: 4, r: 0 } }];

        XLSX.utils.book_append_sheet(new_workbook, worksheet, it.title + '(' + sheetId + ')');
        sheetId++;
      }

      XLSX.writeFile(new_workbook, this.getNowFormatDate() + "_PVA.xlsx");
    },




  },
  computed: {
    ...mapGetters("equipanalysis", { pva: "pva" }),
    ...mapGetters("commonsearch", [
      "searchCategories",
      "hasSelectionResult",
      "hasSearchResult",
      "showSelectionSubmodel",
      "selectionResult",
      "searchResult"
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description"
      };
    },
    carName() {
      return function (idx) {
        if (this.exchange) {
          idx = idx == 0 ? 1 : 0;
        }
        if (this.pva && this.pva.info.length >= 2) {
          return this.pva.info[idx].LineName;
        }
        return "";
      };
    },

    getIdByIndex() {
      return function (idx) {
        return this.pva.info[idx].id;
      };
    },
    DealerPriceDiff() {
      return function () {
        if (
          !this.pva ||
          !this.pva.info ||
          this.pva.info[0].tp == "-" ||
          this.pva.info[1].tp == "-"
        ) {
          return "-";
        }
        var a_index = 0;
        var b_index = 1;
        if (this.exchange) {
          a_index = 1;
          b_index = 0;
        }
        return (
          Number(this.pva.info[a_index].tp) -
          Number(this.pva.info[b_index].tp)
        );
      };
    },

    totalPVA() {
      return function (items) {
        if (!items || items.length == 0) {
          return 0;
        }
        var total = 0;
        for (var v of items) {
          var val = this.getPVAValue(v);
          total += val;
        }
        return total;
      };
    },
    getDataVal() {
      return function (lineId, key) {
        if (!this.pva) {
          return "";
        }
        var info = this.pva.info.filter(x => x.id == lineId)[0];
        if (!info)
          return "";

        if (key == DataKey.MSRP) {

          return parseInt(info.msrp);
        } else if (key == DataKey.DealerPrice) {

          return info.tp;
        } else if (key == DataKey.MSRPPVA) {
          var msrp = parseInt(info.msrp);
          var total = this.totalPVA(idx);
          var percent = ((msrp / total) * 100).toFixed(1) + "%";
          return percent;
        }
      };
    },
    /* compare */

  },
  mounted() {
    //{ids:[74510,74351],val:'A'}
  },
  watch: {
    pva(newValue) {
      if (newValue.pva.length == 0) {
        this.$message({
          message: "当前细分市场' " + this.viewValue + "' 没有数据",
          duration: 2000
        });
      }
    }
  }
};
</script>